import React from 'react';
import { StyledMenuIndustries } from './StyledMenuIndustries';
import { useHistory } from 'react-router-dom'
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

const MenuIndustries = ({ toggle, onlyDesktop, toggleFn}) => {
  const classDestkop = onlyDesktop ? "hide-tablet" : "";
  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      
      toggleFn(false)
      dispatch(setLoader(true))
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }
  
  return (
    <React.Fragment >
      <StyledMenuIndustries className={toggle ? `${classDestkop} show` : `${classDestkop}`}>
        {
          onlyDesktop ?
            <div className="wrapper--flex">
              <h3 className="md--title gradient-fashion fashion-route" onClick={() => handleCLick('/industries/fashion')}>Fashion</h3>
              <h3 className="md--title gradient-real" onClick={() => handleCLick('/industries/real-estate')}>Real Estate</h3>
              <h3 className="md--title gradient-interior" onClick={() => handleCLick('/industries/interior-design')}>Interior Design</h3>
              <h3 className="md--title gradient-cpg" onClick={() => handleCLick('/industries/cpg')}>CPG</h3>
              <h3 className="md--title gradient-more" onClick={() => handleCLick('/industries/generic')}>And more</h3>
            </div>
          : 
          <>
          <div className="row--mobile">
            <p className="grey-400 preset-12">Industries</p>
          </div>
          <div className="wrapper--flex">
              <h6 className="md--title gradient-fashion fashion-route" onClick={() => handleCLick('/industries/fashion')}>Fashion</h6>
              <h6 className="md--title gradient-real" onClick={() => handleCLick('/industries/real-estate')}>Real Estate</h6>
              <h6 className="md--title gradient-interior" onClick={() => handleCLick('/industries/interior-design')}>Interior Design</h6>
              <h6 className="md--title gradient-cpg" onClick={() => handleCLick('/industries/cpg')}>CPG</h6>
              <h6 className="md--title gradient-more" onClick={() => handleCLick('/industries/generic')}>And more</h6>
            </div>
          </>
        }
        
        
      </StyledMenuIndustries>
    </React.Fragment>
  );
};


export default MenuIndustries;
